var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRelease = function SvgRelease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.38 61.85"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.12,8.3c-.79-.6-1.81-.8-2.78-.56l-12.36,3.09c-6.24,1.56-11.32,6.01-13.59,11.9l-1.92,5.01c-13.41.02-16.36,13.5-16.39,13.64-.08.39.01.8.26,1.11s.62.51,1.03.54l5.48.37c-5.25,9.39-2.34,16.82-2.2,17.15.23.57.81.92,1.44.87.04,0,.15-.01.33-.03,1.81-.21,10.25-1.58,15.85-8.6l2.77,8.12c.13.38.42.68.79.84.23.09.48.13.72.1.15-.02.31-.06.45-.13.13-.06,13.28-6.43,9.28-19.58-.05-.17-.15-.33-.26-.46l3.92-2.67c5.29-3.61,8.45-9.51,8.44-15.79v-12.43c-.01-.98-.47-1.89-1.26-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.25,31.72l-19.16,10.24-8.96-8.82,9.92-19.32c2.83-5.51,8.18-9.28,14.32-10.08l13.11-1.72c1.22-.16,2.26.87,2.12,2.08l-1.5,13.13c-.7,6.15-4.39,11.57-9.85,14.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.52,39.86c-4.41,4.48-2.13,11.13-2.13,11.13,0,0,6.68,2.17,11.09-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.69,19.75C6.33,17.64,2,31.01,2,31.01l11.13,2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.34,36.13c2.33,13.31-10.96,17.87-10.96,17.87l-2.31-11.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.83,24.11c-2.47-2.43-2.51-6.41-.07-8.89s6.41-2.51,8.89-.07,2.51,6.41.07,8.89-6.41,2.51-8.89.07Z"
  }))));
};
export default SvgRelease;